import { render, staticRenderFns } from "./AdminVkReviewsView.vue?vue&type=template&id=97720ff0&scoped=true"
import script from "./AdminVkReviewsView.vue?vue&type=script&lang=js"
export * from "./AdminVkReviewsView.vue?vue&type=script&lang=js"
import style0 from "./AdminVkReviewsView.vue?vue&type=style&index=0&id=97720ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97720ff0",
  null
  
)

export default component.exports